// Which Entra app registration this build signs in against.
//
// FMS (966a493e-…) is the default, so an FMS build with no new variables set
// behaves exactly as it always has. The F5 co-founder console overrides both
// values in .env.f5 to point at 4edc52e9-…, whose audience the F5 API is the
// only thing that accepts.
//
// These are read at BUILD time by CRA, not at runtime — a single image cannot
// serve both editions, which is why F5 has its own Dockerfile and pipeline.
const FMS_CLIENT_ID = '966a493e-1e82-4fdc-8c42-2a5d57d0f27a'

const clientId = process.env.REACT_APP_AAD_CLIENT_ID || FMS_CLIENT_ID

// Derived from clientId, never configured independently. Two separate variables
// could disagree — sign in against F5 while requesting the FMS scope — and the
// symptom is a bare 401 the interceptor reads as an expired session, i.e. a
// login loop with nothing in it naming the cause. REACT_APP_API_SCOPE remains
// as an override for the case where the scope is not `api://<clientId>/full`.
const apiScope = process.env.REACT_APP_API_SCOPE || `api://${clientId}/full`

export const msalConfig = {
    auth: {
      clientId,
      authority: "https://login.microsoftonline.com/c7fa89c9-739b-4f77-b860-53335f88b860",
      redirectUri: process.env.REACT_APP_BASE_URL
    },
    cache: {
      cacheLocation: "localStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: true
    }
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: [apiScope]
    // 'api://739d85a6-2f37-44f9-bbe2-bf2631c861cd/full'
}
